import React, { Component } from 'react'
import { connect } from "react-redux";
import { Helmet } from 'react-helmet-async';
import { Button } from 'reactstrap';
import { PDFExport, savePDF } from "@progress/kendo-react-pdf";
import IconButton from '@mui/material/IconButton';
import MatButton from '@mui/material/Button';
import MUIDataTable from "mui-datatables";
import Selectsearch from "react-select"
import "react-datepicker/dist/react-datepicker.css";
import PageTemplate from "Routes/pdfTemplate";
import { NotificationManager } from 'react-notifications';
import ConfirmationDialog from "Routes/common/ConfirmationDialog";
import {
    FormGroup,
    Label,
    Input
} from 'reactstrap';

// intl messages
import IntlMessages from 'Util/IntlMessages';
// page title bar
import PageTitleBar from 'Components/PageTitleBar/PageTitleBar';
// app config
import AppConfig from 'Constants/AppConfig';

import Createvisual from './visualcomponent/createvisual';

import {
    allStudents,
    allMSKVisualisation,
    studentMSKYears,
    mskVisualisationDetails,
    deleteMskVisualisation
} from 'Actions';

// rct card box
import RctCollapsibleCard from 'Components/RctCollapsibleCard/RctCollapsibleCard';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';

class mskvisualisation extends Component {

    constructor(props) {

        super(props);
        this.confirmationDialog = React.createRef();
        this.state = {
            student: '',
            quarter: '',
            seldate: '',
            viewdiv: true,
            repeatHeaders: true,
            errordiv: false,
            visualdiv: false,
            maindiv: false,
            selyear: '',
            selassessment: '',
            visualid: '',
            a1: false,
            a2: false,
            a3: false,
            a4: false,

        };

        this.selectorRef = React.createRef(null);
        this.onBackSection = this.onBackSection.bind(this);
        this.backSection = this.backSection.bind(this);
        this.backMainSection = this.backMainSection.bind(this);
    }

    UNSAFE_componentWillMount() {
        this.props.allStudents();
        var id = '';
        this.props.allMSKVisualisation(id);
    }

    onBackSection() {
        this.setState({
            adddiv: false,
            editdiv: false,
            viewdiv: true
        });
    }

    selectquarter(assmntval) {
        var selstudent = assmntval.value;
        if (selstudent != '') {
            this.setState({ student: selstudent });

            this.props.studentMSKYears(selstudent).then((data) => {

                if (data.status == 1) {
                    this.setState({
                        creatediv: true
                    });
                } else {
                    NotificationManager.error(data.message);
                }

            });

        }
    }

    addHandleReport(assmntval) {
        var student = assmntval.mv_studentID;
        var selyear = assmntval.mv_year;
        var commaSep = assmntval.mv_quaters;
        var id = assmntval.mvID;
        this.setState({
            visualid: id,
            student: student,
            selyear: [...this.state.selyear, selyear],
            selassessment: [...this.state.selassessment, commaSep]

        });
        this.props.mskVisualisationDetails(student, selyear, commaSep, id).then((data) => {

            if (data.status == 1) {
                this.setState({
                    selassessment: commaSep,
                    viewdiv: false,
                    visualdiv: true,
                });
            }
        });


    }

    calculate_age = (dob1) => {
        var today = new Date();
        var birthDate = new Date(dob1);
        var age_now = today.getFullYear() - birthDate.getFullYear();
        var m = today.getMonth() - birthDate.getMonth();
        if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
            age_now--;
        }
        return age_now;
    }

    exportPDFWithMethod = () => {
        this.selectorRef.current.save();
    }

    backSection() {
        this.setState({
            student: '',
            selyear: '',
            selassessment: '',
            visualid: '',
            viewdiv: true,
            creatediv: false,
            visualdiv: false,
            maindiv: false
        });
    }

    backMainSection() {
        this.setState({
            student: '',
            selyear: '',
            selassessment: '',
            visualid: '',
            viewdiv: true,
            creatediv: false,
            visualdiv: false,
            maindiv: false
        });
    }

    handleAddCheckChange(evt, val) {
        let isChecked = evt.target.checked;

        if (isChecked == true) {
            this.setState({ selyear: [...this.state.selyear, val] })
        } else {

            var array = [...this.state.selyear];
            var index = array.indexOf(val)
            if (index !== -1) {
                array.splice(index, 1);
                this.setState({ selyear: array });
            }
        }

    }

    handleAssessmentChange(evt) {
        let isChecked = evt.target.checked;
        let val = evt.target.value;
        if (isChecked == true) {
            this.setState({ selassessment: [...this.state.selassessment, val] })
        } else {

            var array = [...this.state.selassessment];
            var index = array.indexOf(val)
            if (index !== -1) {
                array.splice(index, 1);
                this.setState({ selassessment: array });
            }
        }

    }

    onAddSession() {

        this.setState({
            student: '',
            selyear: '',
            selassessment: '',
            viewdiv: false,
            maindiv: true
        });
    }

    createVisualisation(event) {

        event.preventDefault();
        let { student, selyear, selassessment, visualid } = this.state;

        let totsel = selyear.length;
        let asstot = selassessment.length;
        let commaassement = "";
        if (totsel == 0) {
            NotificationManager.error('Please select atleast any one year');
        } else {
            const commayear = selyear.map(item => item).join(', ');

            if (asstot != 0) {
                commaassement = selassessment.map(item => item).join(', ');
            }

            this.props.mskVisualisationDetails(student, commayear, commaassement, visualid).then((data) => {

                if (data.status == 1) {
                    this.setState({
                        creatediv: true,
                        visualdiv: true,
                    });
                }
            });

        }

    }

    deleteAssessment(id) {
        this.id = id;
        this.confirmationDialog.current.openDialog();
    }

    deleteDataPermanent(popupResponse) {

        if (popupResponse) {
            this.props.deleteMskVisualisation(this.id);
            this.data = ""
        }
    }

    render() {
        const { match, studentlists, mskvisualisationlist, mskyears, loading } = this.props;

        const allstudent = studentlists.map((stdval) => {
            return {
                label: stdval.student,
                value: stdval.uudID
            }
        });


        const options = {
            filterType: 'dropdown',
            rowsPerPage: 50,
            rowsPerPageOptions: [50, 100, 150],
            selectableRowsHideCheckboxes: true,
        };

        const columns = [
            { name: "no", label: "No" },
            { name: "name", label: "Name" },
            { name: "year", label: "Year" },
            { name: "assessment", label: "Assessment No" },
            { name: "date", label: "Date" },
            { name: "action", label: "Action" },
            { name: "delete", label: "Delete" }
        ];

        const tabledata = mskvisualisationlist.map((assmntval, idx) => {

            const ebtn = <MatButton variant="contained" className="btn-icon btn-twitter mr-15 mb-10 text-white" onClick={() => this.addHandleReport(assmntval)}> <i className="zmdi zmdi-file-text"></i> View</MatButton>;
            const dbtn = <IconButton className="text-danger" aria-label="Delete" onClick={() => this.deleteAssessment(assmntval.mvID)}><DeleteOutlineOutlinedIcon/></IconButton>;

            return {
                no: idx + 1,
                name: assmntval.student,
                year: assmntval.mv_year,
                assessment: assmntval.mv_quaters,
                date: assmntval.crdate,
                action: ebtn,
                delete: dbtn
            }
        });


        const styles = {
            table: {
                border: "2px solid rgb(0, 0, 0)",
                borderColor: "rgb(0 0 0 / 49%)",
                borderStyle: "solid"
            },
            tabletrtd: {
                borderWidth: "1px",
                borderStyle: "solid",
                borderColor: "black",
                borderCollapase: "collapse",
                borderSpacing: "0px"
            },
            errmessage: {
                textAlign: "center",
                color: "red"
            }
        };


        return (
            <div className="saas-dashboard">
                <Helmet>
                    <title>MSK Report | {AppConfig.appTitle}</title>
                    <meta name="description" content="Reactify Sass Dashboard" />
                </Helmet>
                <PageTitleBar title={<IntlMessages id="sidebar.mskvisualisationheading" />} match={match} />
                <div className="row">


                    {this.state.viewdiv &&
                        <div className="col-sm-12 col-md-12">
                            <div className="col-md-10">
                                <RctCollapsibleCard heading="Report List" fullBlock>
                                    <MUIDataTable
                                        title={<div><Button onClick={() => this.onAddSession()} className="btn btn-outline-info"><i className="zmdi zmdi-plus-circle-o"></i>  Create Visualisation</Button></div>}
                                        data={tabledata}
                                        columns={columns}
                                        options={options}
                                    />
                                </RctCollapsibleCard>
                            </div>
                        </div>
                    }

                    {this.state.maindiv &&
                        <div className="col-sm-12 col-md-12">
                            <div className="col-sm-12 col-md-4">
                                <RctCollapsibleCard heading="Select Student" backtoadd fullBlock onClick={this.backMainSection}>
                                    <form autoComplete="off" id="addassessmentform" onSubmit={(e) => this.addHandleReport(e)}>
                                        {/* <div className="row">                                     */}
                                       <div className="mt-40">
                                       <div className="col-sm-12 col-md-12">
                                            <FormGroup>
                                                {/* <Label for="Select">Student *</Label> */}
                                                <Selectsearch className="form-control h-auto w-100" id="student" name="student" options={allstudent} value={allstudent.find(obj => obj.value === this.state.student)} onChange={evt => this.selectquarter(evt)} required />
                                            </FormGroup>
                                        </div>
                                       </div>
                                        {/* </div> */}
                                    </form>

                                </RctCollapsibleCard>
                            </div>
                        </div>


                    }

                    {this.state.creatediv &&
                        <div className="col-sm-12 col-md-12">
                            <div className="col-md-8" >
                                <RctCollapsibleCard heading="Make Visualisation" fullBlock>
                                    <form autoComplete="off" id="createform" onSubmit={(e) => this.createVisualisation(e)} style={{ padding: "20px" }}>
                                        <div className="row">
                                            <div className="col-sm-6 col-md-2">
                                                <FormGroup>
                                                    <Label for="Select">Year *</Label>
                                                    <br />
                                                    {mskyears.map((gleval) => (
                                                        <div>
                                                            <span style={{ fontSize: "15px", padding: "15px", fontWeight: "500" }}><input type="checkbox" color="primary" name="years" value={gleval.cyear} onChange={evt => this.handleAddCheckChange(evt, gleval.cyear)} style={{ width: "18px", height: "18px", marginRight: "5px" }} />
                                                                {gleval.cyear}</span>
                                                            <br />
                                                        </div>
                                                    ))}
                                                </FormGroup>
                                            </div>
                                            <div className="col-sm-6 col-md-6">
                                                <FormGroup>
                                                    <Label for="Select">Assessment *</Label>
                                                    {mskyears.map((gleval) => (
                                                        <div>
                                                            {gleval.assessment.map((assval) => (

                                                                <span style={{ fontSize: "15px", padding: "15px", fontWeight: "500" }}><input type="checkbox" color="primary" name="assessment" value={gleval.cyear + "_" + assval.no} onChange={evt => this.handleAssessmentChange(evt)} style={{ width: "18px", height: "18px", marginRight: "5px" }} />
                                                                    {"A" + assval.no}</span>

                                                            ))}
                                                        </div>
                                                    ))}
                                                </FormGroup>
                                            </div>
                                            <div className="form-group">
                                                <input type="submit" className="mr-3 mb-3 btn btn-outline-primary" value="Submit" />
                                                <input type="button" className="mr-3 mb-3 btn btn-outline-warning" onClick={this.backSection} value="Back" />
                                            </div>
                                        </div>
                                    </form>
                                </RctCollapsibleCard>
                            </div>
                        </div>
                    }

                    {this.state.visualdiv &&

                        <div className="col-sm-12 col-md-6" style={{ margin: "0 auto" }}>
                            <Createvisual onClick={this.backSection} data={this.state} />
                        </div>


                    }

                    {this.state.errordiv &&
                        <div className="col-sm-12 col-md-8">
                            <h4 style={styles.errmessage}> No Record Found </h4>
                        </div>
                    }

                    <ConfirmationDialog
                        ref={this.confirmationDialog}
                        onConfirm={(res) => this.deleteDataPermanent(res)}
                        data={'Record'}
                    />
                </div>

            </div>
        )
    }
}


const mapStateToProps = ({ mostlyused, mskvisualisation }) => {
    const { mskvisualisationlist, mskyears } = mskvisualisation;
    const { studentlists, loading } = mostlyused;
    return { studentlists, mskvisualisationlist, mskyears, loading };

}

export default connect(mapStateToProps, {
    allStudents,
    allMSKVisualisation,
    studentMSKYears,
    mskVisualisationDetails,
    deleteMskVisualisation
})(mskvisualisation); 